import {
  SmartComponentPropertyDetails,
  SmartComponentSummaryData,
} from "../smart-components/smart-component-property-details";
import { SkillNameList } from "../../enum/enumSkillNameList";
import { IComponentLoader } from "../../interfaces/IComponentLoader";
import { ComponentAdapterParent } from "./component-adapter-parent";
import { AddressDetails } from "../smart-components/smart-component-property";
import { ComponentAdapterCounterParent } from "./component-adapter-counter-parent";

/**
 * Component adapter for counter hot water
 */
export class ComponentAdapterCounterHotWater
  extends ComponentAdapterCounterParent
  implements IComponentLoader
{
  private _volume: AddressDetails = null;
  private _flow: AddressDetails = null;

  /**
   * Get address about volume skill
   */
  get Volume(): AddressDetails {
    return this._volume;
  }

  /**
   * Get address about power skill
   */
  get Flow(): AddressDetails {
    return this._flow;
  }

  constructor() {
    super();
  }

  public fillProperty(
    listSmartComponentSkills: Array<SmartComponentPropertyDetails>,
    data: SmartComponentSummaryData
  ): void {
    this._summary = data.summary;
    this._idSmartComponentKind = data.idSmartComponentKind;
    this._idEnvironment = data.idEnvironment;
    this._name =
      listSmartComponentSkills.find(
        (titleSkill) =>
          titleSkill.titleSkill === SkillNameList.COUNTER_HOTWATER_NAME
      )?.value || "";
    this._description =
      listSmartComponentSkills.find(
        (titleSkill) =>
          titleSkill.titleSkill === SkillNameList.COUNTER_HOTWATER_DESCRIPTION
      )?.value || "";
    this._volume =
      listSmartComponentSkills.find(
        (titleSkill) =>
          titleSkill.titleSkill === SkillNameList.COUNTER_HOTWATER_VOLUME
      )?.address || null;
    this._flow =
      listSmartComponentSkills.find(
        (titleSkill) =>
          titleSkill.titleSkill === SkillNameList.COUNTER_HOTWATER_FLOW
      )?.address || null;

    this.fillMissingProperty();
    this.fillAddressState();
  }

  public fillMissingProperty(): void {}

  public fillAddressState(): void {}
}
